import React from 'react';

export default function PageTitle({ title }) {
  return (
    <div className={'mt-16 lg:mt-0 mb-5'}>
      <h3 className={'font-medium text-xl text-gray-500'}>{title}</h3>
    </div>
  );
}
